import { StyleSheet, Text } from 'react-native'
import React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { RootStackParamList } from './Types/uitypes';
import {
  CoupansScreen, LoginScreen,
  SignUpScreen, ForgotPasswordScreen
} from './screens';
import PasswordResetScreen from './screens/PasswordResetScreen/PasswordResetScreen';
import SplashScreen from './screens/SplashScreen/SplashScreen';
import UpdatePasswordScreen from './screens/UpdatePasswordScreen/UpdatePasswordScreen';

const Stack = createNativeStackNavigator<RootStackParamList>();

// Linking config for web URLs
const linking = {
  prefixes: [window.location.origin], // syncs with current host
  config: {
    screens: {
      LoginScreen: 'login',
      SignUpScreen: 'signup',
      ForgotPasswordScreen: 'forgot-password',
      CoupansScreen: 'coupons',
    },
  },
};

export default function App() {
  return (
    <NavigationContainer linking={linking} fallback={<Text>Loading...</Text>}>
      <Stack.Navigator initialRouteName="SplashScreen" screenOptions={{ headerShown: false }}>
        <Stack.Screen name="CoupansScreen" component={CoupansScreen} />
        <Stack.Screen name="LoginScreen" component={LoginScreen} />
        <Stack.Screen name="SignUpScreeen" component={SignUpScreen} />
        <Stack.Screen name="ForgotPasswordScreen" component={ForgotPasswordScreen} />
        <Stack.Screen name="PasswordResetScreen" component={PasswordResetScreen} />
        <Stack.Screen name="SplashScreen" component={SplashScreen} />
        <Stack.Screen name="UpdatePasswordScreen" component={UpdatePasswordScreen} />
      </Stack.Navigator>
    </NavigationContainer>
  )
}

const styles = StyleSheet.create({})


// npx expo export:web